import util from '../../../util'

const saveOrder = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.post('orders/save', payload.order, {headers}).then((response) => {
      commit('addOrder', response.data)
      resolve(response.data)
    }).catch(error => {
      util.showDialogError(payload.context, 'Ocurrió un error al registrar el pedido.')
      reject(error)
    });
  })

};

const loadOrders = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.get(`orders/${payload.idClient}?${payload.params}`, {headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      util.showDialogError(payload.context, 'Ocurrió un error al cargar los pedidos.')
      reject(error)
    });
  })

}

const loadOrdersInClient = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader();

    let query = '';
    if (payload.type) {
      query = `?type=${payload.type}`;
    } else if (payload.params) {
      query = `?${payload.params}`;
    }

    payload.context.axios
      .get(`orders/${payload.idClient}/inclient${query}`, { headers })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.error('Error en loadOrdersInClient:', error);
        reject(error);
      });
  });
};

const cancelOrder = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.delete(`orders/${payload.idOrder}`, {headers}).then((response) => {
      payload.context.$toast.open('Pedido cancelado correctamente!')
      resolve(response.data)
    }).catch(error => {
      util.showDialogError(payload.context, 'Ocurrió un error al cancelar el pedido.')
      reject(error)
    });
  })

}

const doPostGetBlob = ({commit}, payload) => {
  const headers = util.getAuthHeader()
  return new Promise((resolve, reject) => {
    payload.context.axios.post(payload.url, {}, {headers, responseType: 'blob'}).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
      resolve(url)
    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, "Reporte no encontrado", 'error')
        reject(error)
      } else reject(error)

    });
  })

};

const saveOrderCajas = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.post(`orders/savebox?${payload.params}`, payload.order, {headers}).then((response) => {
      payload.context.$toast.open('Pedido registrado correctamente!')
      resolve(response.data)
    }).catch(error => {
      util.showDialogError(payload.context, 'Ocurrió un error al registrar el pedido.')
      reject(error)
    });
  })

};

export default {
  saveOrder,
  loadOrders,
  cancelOrder,
  loadOrdersInClient,
  doPostGetBlob,
  saveOrderCajas
};



// WEBPACK FOOTER //
// ./src/store/modules/orders/actions.js